/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import Api from 'app/api/Api';
import {useApi} from "app/api/APIProvider";
import {APIError} from "app/api/NewAPI";
import {useNavigate} from "react-router-dom";
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { classNames } from 'shared/lib/classNames/classNames';
import cls from './AvatarForm.module.scss';
import { useDispatch } from 'react-redux';
import { userActions } from 'features/User';
import axios from 'axios';

type FormData = {
  avatar_name: string;
  avatar: 'm' | 'w';
};

interface SignUpProps {
    className?: string,
    stateHandler?: (value: 'm' | 'w') => void,
}

export const AvatarForm: React.FC<SignUpProps> = ({ className, stateHandler }) => {
    const api = useApi()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [avatar, setAvatar] = useState<'m' | 'w'>('m');
    const [deviceType, setDeviceType] = useState('Unknown');
    const [location, setLocation] = useState('Unknown');
    const {
        control,
        handleSubmit,
        register,
        setError,
        setValue,
        formState: { errors },
    } = useForm<FormData>({ mode: 'onChange' });

    const onSubmit: SubmitHandler<FormData> = async (data) => {
        try {
            await api.EditUser({...data});
            sessionStorage.setItem("isDropped", 'false');
            navigate('/plot');
        } catch (err) {
            setError('avatar_name', { message: "Произошла ошибка" });
        }
    };

    const getLocation = async () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                const { latitude, longitude } = position.coords;
                setLocation(`latitude: ${latitude}, longitude: ${longitude}`);
              },
              (error) => {
                console.log(`Error: ${error.message}`);
              }
            );
          } else {
            console.log("Geolocation is not available in your browser.");
          }
    };

    const getUsingDevice = () => {
        const userAgent = navigator.userAgent;
        if (userAgent.match(/Android/i)) {
            setDeviceType('Android');
        } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
            setDeviceType('iOS');
        } else if (userAgent.match(/Windows/i)) {
            setDeviceType('Windows');
        } else if (userAgent.match(/Mac/i)) {
            setDeviceType('Mac');
        } else if (userAgent.match(/Linux/i)) {
            setDeviceType('Linux');
        }
    }

    useEffect(() => {
        setValue('avatar', 'm');
        getUsingDevice();
        getLocation();
    }, []);

    return (
        <div className={cls.formWrapper}>
            <Title className={cls.title} color="#000000A6" size={TitleSize.title_32_400}>Выберите персонажа</Title>
            <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={cls.cell}>
                    <div className={cls.genderWrapper}>
                        <Button
                            className={classNames(cls.genderButton, { [cls.active]: avatar === 'm' })}
                            theme={ButtonTheme.PRIMARY}
                            onClick={() => {
                                setValue('avatar', 'm');
                                setAvatar('m');
                                stateHandler('m');
                            }}
                        >
                            Мальчик
                        </Button>
                        <Button
                            className={classNames(cls.genderButton, { [cls.active]: avatar === 'w' })}
                            theme={ButtonTheme.PRIMARY}
                            onClick={() => {
                                setValue('avatar', 'w');
                                setAvatar('w');
                                stateHandler('w');
                            }}
                        >
                            Девочка
                        </Button>
                    </div>
                </div>
                <div className={cls.cell}>
                    <input
                        className={cls.field}
                        {...register('avatar_name', { required: 'Введите имя', validate: value => value.match(/[^а-я0-9-]/mui) == null || "Введите имя без символов"})}
                        placeholder="Введите имя персонажа"
                    />
                    {errors.avatar_name && <p className={cls.error}>{errors.avatar_name.message}</p>}
                </div>
                <Button type="submit" className={cls.button} theme={ButtonTheme.PRIMARY}>
                    Начать
                </Button>
            </form>
            <Text className={cls.notion} color="#000000A6" size={TextSize.text_14}>ООО СК «СберСтрахование жизни»</Text>
        </div>
    );
};


